import React,{useEffect,useState,useCallback} from "react";

import {
Card,
Row,
Col,
Table,
Typography,
Input,
Select,
Spin,
Alert,
Avatar,
Tag,
Modal,
Button,
Space
} from "antd";


import {
SearchOutlined,
TrophyOutlined,
DownloadOutlined,
TeamOutlined,
FilePdfOutlined
} from "@ant-design/icons";


import {
useAcademicYear
} from "../../AcademicYearContext";


import api from "../../api/api";


import HighAveragesPagePDF from "./HighAveragesPagePDF";


import {
PDFDownloadLink
} from "@react-pdf/renderer";



const {
Title,
Text
}=Typography;


const {
Option
}=Select;



const HighAveragesPage=()=>{


const {
selectedYear
}=useAcademicYear();



const [gradeClasses,setGradeClasses]=useState([]);

const [selectedClass,setSelectedClass]=useState("");

const [students,setStudents]=useState([]);

const [loading,setLoading]=useState(false);

const [error,setError]=useState("");

const [search,setSearch]=useState("");

const [showPDFModal,setShowPDFModal]=useState(false);

const [reportData,setReportData]=useState(null);



const loadGradeClasses=useCallback(async()=>{


try{


const response=await api.get(
"/api/users/grade-classes/"
);


setGradeClasses(
response.data.results ||
response.data
);


}catch(error){

console.log(error);

}


},[]);




useEffect(()=>{

loadGradeClasses();

},[
loadGradeClasses
]);






const loadStudents=useCallback(async()=>{


if(!selectedClass){

return;

}


try{


setLoading(true);

setError("");



const response=await api.get(
"/top-student-summary/",
{
params:{

academic_year:selectedYear?.id,

grade_class:selectedClass,

search

}

}
);



const data=
response.data.results;



setStudents(
data.students || []
);



setReportData({

academic_year:
data.academic_year,

grade_class:
data.grade_class,

students:
data.students || []

});



}catch(error){


console.log(error);


setError(
"Unable to load top performing students."
);



}finally{


setLoading(false);


}



},[
selectedClass,
selectedYear,
search
]);





useEffect(()=>{


if(selectedClass){

loadStudents();


}


},[
selectedClass,
loadStudents
]);






const handleGradeClassChange=(value)=>{


setSelectedClass(value);


setShowPDFModal(true);


};







const columns=[


{

title:"Rank",

dataIndex:"rank",

width:100,

render:(rank)=>(


<Avatar

style={{

background:
rank===1
?
"#b8860b"
:
rank===2
?
"#777"
:
rank===3
?
"#8b4513"
:
"#800000"

}}

>

{rank}

</Avatar>


)


},



{


title:"Student Name",

dataIndex:"student_name",

render:(name)=>(

<Space>

<TeamOutlined

style={{

color:"#800000"

}}

/>

<Text strong>

{name}

</Text>


</Space>

)


},



{

title:"Grade Class",

dataIndex:"grade_class",

render:(value)=>(

<Tag

color="#800000"

>

{value}

</Tag>

)


},



{

title:"Yearly Average",

dataIndex:"yearly_average",

align:"center",

render:(value)=>(


<Tag

color={
value>=95
?
"green"
:
value>=90
?
"blue"
:
"orange"
}

>

{value}%

</Tag>


)

}


];






return(


<div

style={{

padding:24,

background:"#f3f3f3",

minHeight:"100vh"

}}

>


<Card

style={{

borderRadius:15,

background:
"linear-gradient(135deg,#800000,#4b0000)",

marginBottom:24

}}

>


<Title

level={2}

style={{

color:"#fff",

margin:0

}}

>

<TrophyOutlined/>

{" "}

Top Performing Students

</Title>


<Text

style={{

color:"#ddd"

}}

>

Academic Year:

{" "}

<strong>

{
selectedYear?.name ||
"Loading..."
}

</strong>

</Text>


</Card>







<Row

gutter={[16,16]}

style={{

marginBottom:20

}}

>


<Col

xs={24}

md={8}

>


<Card

style={{

borderRadius:12

}}

>


<Text

type="secondary"

>

Selected Grade Class

</Text>


<Select

showSearch

placeholder="Select Grade Class"

style={{

width:"100%",

marginTop:10

}}

value={selectedClass || undefined}


onChange={
handleGradeClassChange
}

>


{

gradeClasses.map(item=>(


<Option

key={item.id}

value={item.id}

>

{item.name}

</Option>


))


}


</Select>


</Card>


</Col>





<Col

xs={24}

md={8}

>


Card

<Card

style={{

borderRadius:12

}}

>


<Text

type="secondary"

>

Qualified Students

</Text>


<Title

level={3}

style={{

margin:0,

color:"#800000"

}}

>

{students.length}

</Title>


</Card>


</Col>







<Col

xs={24}

md={8}

>


<Card

style={{

borderRadius:12

}}

>


<Text

type="secondary"

>

Report Status

</Text>


<Title

level={4}

style={{

margin:0

}}

>

{selectedClass?

"Ready"

:

"Select Class"}

</Title>


</Card>


</Col>



</Row>







<Card

style={{

borderRadius:15

}}

>


<Input

prefix={<SearchOutlined/>}

placeholder="Search student..."

value={search}

onChange={(e)=>setSearch(e.target.value)}

style={{

marginBottom:20

}}

/>





{

loading?


<Spin

size="large"

/>



:


error?


<Alert

message={error}

type="error"

/>



:


<Table

columns={columns}

dataSource={students}

rowKey="student_id"

pagination={{

pageSize:25

}}

/>



}



</Card>







<Modal

title={

<Space>

<FilePdfOutlined/>

Download High Average Report

</Space>

}

open={showPDFModal}

onCancel={()=>setShowPDFModal(false)}

footer={null}

>


<p>

You selected a grade class.

Would you like to download the High Average PDF report?

</p>



<Space>


<PDFDownloadLink

document={

<HighAveragesPagePDF

data={reportData}

/>

}

fileName={

`High_Averages_${reportData?.grade_class}.pdf`

}

>


{

({loading})=>(


<Button

type="primary"

danger

icon={<DownloadOutlined/>}

disabled={loading}

>

Yes, Download PDF

</Button>


)

}


</PDFDownloadLink>





<Button

onClick={()=>setShowPDFModal(false)}

>

No

</Button>


</Space>



</Modal>






</div>


);


};


export default HighAveragesPage;